module.exports = __webpack_public_path__ + "img/h.ffbf323b.jpg";